import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { calendarEventsApi } from "../api/calendarEventsApi";

// Compromisso não mexe em nenhum total: só a própria lista é invalidada (nada de
// invalidateShiftQueries). O aviso de conflito consulta o backend na hora, sem cache.
const ROOT_KEY = "compromissos";

export function useCalendarEventsQuery({ de, ate }) {
  return useQuery({
    queryKey: [ROOT_KEY, { de, ate }],
    queryFn: () => calendarEventsApi.list({ de, ate }),
  });
}

function useCalendarEventMutation(mutationFn) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ROOT_KEY] }),
  });
}

export const useCreateCalendarEventMutation = () => useCalendarEventMutation(calendarEventsApi.create);
export const useUpdateCalendarEventMutation = () => useCalendarEventMutation(calendarEventsApi.update);
export const useDeleteCalendarEventMutation = () => useCalendarEventMutation(calendarEventsApi.remove);
